import MenuSm from './menu.sm';
import MenuConsended from './menu.consended';
import MenuMaster from './menu.master';
import MenuProfile from './menu.user';

const Menu = () => {
  return;
};

Menu.Consended = MenuConsended;
Menu.Mobile = MenuSm;
Menu.Master = MenuMaster;
Menu.User = MenuProfile;

export default Menu;
